import { render, staticRenderFns } from "./SecondaryPageContainer.vue?vue&type=template&id=375d2ffc&scoped=true"
import script from "./SecondaryPageContainer.vue?vue&type=script&lang=js"
export * from "./SecondaryPageContainer.vue?vue&type=script&lang=js"
import style0 from "./SecondaryPageContainer.vue?vue&type=style&index=0&id=375d2ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d2ffc",
  null
  
)

export default component.exports